import { StateKey } from 'common/utils/flipState'
import { fetchMyBasicAddress } from 'common/services/address'

export const DEFAULT_USER_ADDRESS = '서울 경기'

export interface MyAddress {
  nid: string
  baseAddress: string
}

const initialState: MyAddress = {
  nid: '',
  baseAddress: '',
}

const FETCH_MY_ADDRESS = 'personalized/FETCH_MY_ADDRESS'

export const fetchBasicAddress = (curState: StateKey, headers?: any) => async dispatch => {
  const addresses = await fetchMyBasicAddress(headers)
  dispatch({
    curState,
    addresses: addresses || initialState,
    type: FETCH_MY_ADDRESS,
  })
}

const myAddressReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MY_ADDRESS:
      return action.addresses
    default:
      return state
  }
}

export default myAddressReducer
